function getDateOneMonthBeforeToday() {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 1);
    return currentDate;
}

export function getDateforDemo() {
    const currentDate = new Date();
    currentDate.setFullYear(2021);
    return currentDate;
}

export default getDateOneMonthBeforeToday;
